module.exports = __webpack_public_path__ + "img/newsletter_icon.84699241.svg";